import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, defer, map, shareReplay } from 'rxjs';

export interface UserPermissions {
  permissions: string[];
  roles: string[];
  resource_permissions?: string[]
}

@Injectable()
export class PermissionsApiService {
  private readonly baseUrl: string;
  private permissions$: Observable<UserPermissions>;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = window['__AnPlatformConfiguration__'].identityApi?.baseUrl;

    if (this.baseUrl) {
      this.permissions$ = defer(() => this.httpClient.get<UserPermissions>(`${this.baseUrl}/user/permissions`)).pipe(
        map((permissionsObject) => ({
          ...permissionsObject,
          roles: permissionsObject.roles || [],
          permissions: permissionsObject.permissions?.filter(Boolean) || []
        })),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }
  }

  getPermissions(): Observable<UserPermissions> {
    return this.permissions$;
  }
}
